import { ModalsModule } from '@anecdotes/design-system/modals';
import { ModuleWithProviders, NgModule } from '@angular/core';
import { DynamicFormModule } from '@anecdotes/dynamic-form';
import {
  CsvFormatterService,
  FileDownloadingHelperService,
  LoggerService,
  PdfService,
} from './services';
import { ContactUsWidgetService } from '@anecdotes/support';

@NgModule({
  imports: [ModalsModule, DynamicFormModule],
})
export class HelpersModule {
  static forRoot(): ModuleWithProviders<HelpersModule> {
    return {
      ngModule: HelpersModule,
      providers: [
        LoggerService,
        ContactUsWidgetService,
        FileDownloadingHelperService,
        CsvFormatterService,
        PdfService,
      ],
    };
  }
}
